import * as Labels from "./Labels";
import { NON_AUTOCLASSIFIABLE_ADTYPES } from "utils/constants";
import { getAutoClassificationEnabled } from "./Intelligence";
import { isApproved } from "utils/CreativeActions";

/**
 * getCurrentCreativeAutoClassifiable determines if a creative can be sent for Auto-Classification
 * @param {*} state redux state to be passed
 * @returns boolean
 */
export function getCurrentCreativeAutoClassifiable(state) {
	const {
		adType,
		autoClassificationStatus: creativeAutoClassificationStatus,
		approval,
	} = state.creativeDetails || {};
	const isAutoClassificationEnabled = getAutoClassificationEnabled(state);
	const isClassifiableAdType = !NON_AUTOCLASSIFIABLE_ADTYPES.includes(adType);

	return [
		isAutoClassificationEnabled,
		isClassifiableAdType,
		isApproved(approval),
		creativeAutoClassificationStatus === "Not Classified",
	].every(item => item);
}

/**
 * getCurrentVersionAutoClassifiable determines if a version can be sent for Auto-Classification
 * @param {*} state redux state to be passed
 * @param {*} versionDetails object containing details of the version to help determine if it can be sent for auto-classification
 * @returns boolean
 */
export function getCurrentVersionAutoClassifiable(state, versionDetails = {}) {
	const { autoClassificationStatus, status } = versionDetails;

	return [
		Labels.getCurrentCreativeAutoClassifiable(state),
		autoClassificationStatus === "Not Classified",
		status === "Live",
	].every(item => item);
}
